<template>
  <div>
    <el-row>
      <el-alert type="warning" show-icon v-if="!currentUser.approved" :closable="false"
        :title="$t('accountUnapprovedTitle')" :description="$t('accountUnapprovedDescription')" />
      <ul class="user__meta">
        <li class="user__email" v-if="currentUser.email">{{ $t('accountSettingsEmailLabel') }}: {{ currentUser.email }}
        </li>
        <li class="user__dealership" v-if="dealer">{{ $t('accountSettingsDealerAssociationLabel') }}: {{ dealer.title }}
        </li>
      </ul>
      <el-button @click.prevent="logOut()" type="default">
        {{ $t('applicationLogout') }}
      </el-button>
      <router-link :to="{ name: 'Help' }">
        <el-button type="default">{{ $t('menuHelp') }}</el-button>
      </router-link>
      <router-link :to="{ name: 'Contact' }">
        <el-button type="default">{{ $t('menuContact') }}</el-button>
      </router-link>
    </el-row>
    <hr class="divider">
    <el-row>
      <el-form class="form form__settings" ref="form" @submit.native.prevent="onSubmit()" v-loading="!!loading">
        <messages :messages="messages"></messages>
        <input-first-name-field id="firstName" v-model="localFirstName" />
        <input-last-name-field id="lastName" v-model="localLastName" />
        <input-language-dropdown id="language" :value="localLanguage" @change="setLocalLanguage" />
        <el-button type="primary" native-type="submit">
          {{ $t('applicationSave') }}
        </el-button>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import authentication from '@/authentication';
import user from '@/components/user';
import InputFirstNameField from '@/components/inputs/InputFirstNameField.vue';
import InputLastNameField from '@/components/inputs/InputLastNameField.vue';
import InputLanguageDropdown from '@/components/inputs/InputLanguageDropdown.vue';
import Messages from '@/components/Messages.vue';
import { mapActions, mapState } from 'vuex';
import i18n from '@/configured/vue-i18n';
import { writeStoredLocale } from '@/configured/locale-storage';
import { loadBaseDataIfNeeded } from '@/base-data';

export default {
  name: 'UserInfo',
  data() {
    return {
      messages: [],
      loading: false,
      request: null,
      localLanguage: this.$store.state[i18n.store.namespace].language || '',
      localFirstName: this.$store.state[user.store.namespace].currentUser.firstName || '',
      localLastName: this.$store.state[user.store.namespace].currentUser.lastName || ''
    }
  },
  computed: {
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    dealer() { return this.$store.getters[`${user.store.namespace}/dealer`](); }
  },
  methods: {
    ...mapActions(authentication.store.namespace, [
      'logOut',
    ]),
    ...mapActions(user.store.namespace, [
      'updateUserData',
    ]),
    async onSubmit() {
      this.loading = true;
      this.messages.splice(0, this.messages.length);

      this.request = this.updateUserData({
        firstName: this.localFirstName,
        lastName: this.localLastName,
        preferredLanguage: this.localLanguage
      });

      try {
        await this.request;

        if (this.localLanguage !== this.$store.state[i18n.store.namespace].language) {
          await i18n.loadLanguageAsync(this.localLanguage);
          await loadBaseDataIfNeeded({
            forceInline: true,
            mode: 'language-refresh',
          });
        }

        this.handleSuccess();
      } finally {
        this.loading = false;
      }
    },
    handleSuccess() {
      this.messages.splice(0, this.messages.length);
      this.messages.push({
        text: i18n.i18n.t('accountSettingsUpdateInfoSuccess'),
        type: 'success',
        id: new Date().getTime().toString()
      });
    },
    setLocalLanguage(language) {
      this.localLanguage = language;
      writeStoredLocale(language);
    }
  },
  components: {
    InputLanguageDropdown,
    InputFirstNameField,
    InputLastNameField,
    Messages
  }
}
</script>

<style lang="scss" scoped>
.user__meta {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
}
</style>
